import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { h2 } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import styled from 'styled-components';
const Container = styled.section `
  position: relative;
  display: block;

  .equally-ai___high-saturation & {
    filter: saturate(200%);
  }

  .equally-ai___reverse-contrast & {
    filter: invert(100%);
  }

  .equally-ai___monochrome-contrast & {
    filter: grayscale(100%);
  }

  .equally-ai___reverse-contrast.equally-ai___monochrome-contrast & {
    filter: grayscale(100%) invert(100%);
  }
`;
const Grid = styled.div `
  ${baseGrid};

  position: relative;

  @media ${until(Device.Tablet)} {
    row-gap: 32px;
  }
`;
const Title = styled.h2 `
  ${h2}
`;
const ContentArea = styled.div `
  grid-column: span 12;

  @media ${from(Device.Tablet)} {
    grid-column: 3 / span 8;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 4 / span 6;
  }

  ${ButtonStyles.Button} {
    margin: ${fluid(16, 24)} 0 0;
  }
`;
const FaqAccordionStyles = {
    Container,
    ContentArea,
    Grid,
    Title,
};
export default FaqAccordionStyles;
